var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"steps"}},[_c('span',{attrs:{"id":"step"}},[_vm._v("STEP "+_vm._s(_vm.step))]),_vm._v(" OF 9")])}
var staticRenderFns = []

export { render, staticRenderFns }